import { useTranslation } from 'react-i18next';

import { EmptyDataMessage } from '@/ui';
import type { Incident, PortalCall } from '@/signalr/contracts';
import { CallNotificationListComponent } from './CallNotificationListComponent';
import { CallNotificationsListItemPlaceholder } from '@/features/shared/IncidentListLoadingPlaceholder';

export type CallNotificationListProps = {
  callNotifications: readonly PortalCall[];
  incidents: readonly Incident[];
  isLoading?: boolean;
};

export function CallNotificationList({ callNotifications, incidents, isLoading = false }: CallNotificationListProps) {
  const { t } = useTranslation();

  return (
    <div className="p-2 mt-2">
      <h2>{t('CallNotification_IncomingCalls')}</h2>

      {isLoading ? (
        <CallNotificationsListItemPlaceholder />
      ) : callNotifications.length > 0 ? (
        <CallNotificationListComponent callNotifications={callNotifications} incidents={incidents} />
      ) : (
        <EmptyDataMessage text={t('CallNotification_NoRecentCallNotifications')} />
      )}
    </div>
  );
}
